import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-date-scroll',
  templateUrl: './date-scroll.component.html',
  styleUrls: ['./date-scroll.component.css']
})
export class DateScrollComponent implements OnInit, OnChanges {

  private day: number;
  private month: number;
  private year: number;
  @Input() fieldName: string;
  @Input() defaultDay?: number;
  @Input() defaultMonth?: number;
  @Input() defaultYear?: number;
  @Input() minYear: number;
  @Input() maxYear: number;
  @Output() dateChange = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    if (!this.defaultDay) { this.day = this.defaultDay = 15; } else { this.day = this.defaultDay; }
    if (!this.defaultMonth) { this.month = this.defaultMonth = 6; } else { this.month = this.defaultMonth; }
    if (!this.defaultYear) { this.year = this.defaultYear = 2020; } else { this.year = this.defaultYear; }
    this.emitDateChange(this.generateDate());
  }
  ngOnChanges(changes: import ('@angular/core').SimpleChanges): void {
    this.year = changes.defaultYear.currentValue;
    // defaultMonth & defaultDay attributes should be set on the parent component to be available for use in ngOnchanges
    // this.month = changes.defaultMonth.currentValue;
    // this.day = changes.defaultDay.currentValue;
    this.emitDateChange(this.generateDate());
  }
  generateDate(): string {
    return this.year + '-' + this.month + '-' + this.day;
  }
  emitDateChange(date: string): void {this.dateChange.emit({fieldName: this.fieldName, date}); }
  onDayChange(day: number) {
    this.day = day;
    this.emitDateChange(this.generateDate());
  }

  onMonthChange(month: number) {
    this.month = month;
    this.emitDateChange(this.generateDate());
  }

  onYearChange(year: number) {
    this.year = year;
    this.emitDateChange(this.generateDate());
  }
}
